import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"

import { cn } from "@/lib/utils"

const clampProgress = (value) => Math.max(0, Math.min(100, Number(value) || 0));

const Progress = React.forwardRef(
  ({ className, value, indeterminate = false, ...props }, ref) => {
    const progressValue = clampProgress(value);

    return (
      <ProgressPrimitive.Root
        ref={ref}
        value={indeterminate ? undefined : progressValue}
        className={cn(
          "relative h-2 w-full overflow-hidden rounded-full bg-primary/20",
          className
        )}
        {...props}>
        <ProgressPrimitive.Indicator
          className={cn(
            "h-full bg-primary",
            indeterminate
              ? "w-1/3 doe-progress-indeterminate"
              : "w-full flex-1 transition-all"
          )}
          style={
            indeterminate
              ? undefined
              : { transform: `translateX(-${100 - progressValue}%)` }
          } />
      </ProgressPrimitive.Root>
    );
  }
)
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
